import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import SmartIndexLayout from 'layouts/crud/SmartIndexLayout'
import ViewLinkSmartview from 'widgets/smartviews/links/ViewLinkSmartview'

export default class Index extends CrudPageContent {
  get resourceName () {
    return 'links'
  }

  get layout () {
    return SmartIndexLayout
  }

  get filters () {
    return (
      <>
        <Filters.SearchFilter />
        <Filters.EnumFilter name='status' enum='link_status' placeholder='Vælg status' />
      </>
    )
  }

  get columns () {
    return (
      <>
        <Columns.Text name='domain_name' label='Domæne' />
        <Columns.Text name='title' label='Titel' />
        <Columns.Enum enum='link_status' name='status' />
        <Columns.DateTime name='publish_at' label='Udgives' sortSlug='orderByPublishAt' />
      </>
    )
  }

  renderAfterCrud () {
    return null
  }

  get crudProps () {
    return {
      ...super.crudProps,
      smartview: <ViewLinkSmartview />
    }
  }
}
